module.exports = __webpack_public_path__ + "assets/img/block-hover-f6a16dcc.png";